import { styled } from "@/styles/stitches.config";
import { installPwa, isPwaInstallable } from "@/utils/pwa-install";
import { getText } from "@/utils/util";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Nav = styled("nav", {
  display: "flex",
  alignItems: "center",
  gap: "$3",
});

const NavItem = styled("a", {
  color: "$text",
  fontSize: "$2",
  textDecoration: "none",
  padding: "$2",
  borderRadius: "$1",
  transition: "all 0.2s",
  cursor: "pointer",

  "&:hover": {
    color: "$primary",
    backgroundColor: "rgba(22,119,255,0.1)",
  },

  variants: {
    active: {
      true: {
        color: "$primary",
      },
    },
    theme: {
      light: {
        color: "$text",
      },
      dark: {
        color: "$textLight",
      },
    },
  },
});

interface MenuProps {
  theme?: "light" | "dark";
}

export function Menu({ theme = "light" }: MenuProps) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();

  return (
    <Nav>
      <NavItem theme={theme} onClick={() => navigate("/homecenter")}>
        {translate(getText("首頁"))}
      </NavItem>
      <NavItem theme={theme} onClick={() => navigate("/quotation")}>
        {translate(getText("行情"))}
      </NavItem>
      <NavItem theme={theme} onClick={() => navigate("/trade/btc")}>
        {translate(getText("交易"))}
      </NavItem>
      <NavItem theme={theme} onClick={() => navigate("/propertycenter")}>
        {translate(getText("資產"))}
      </NavItem>
      <NavItem theme={theme} onClick={() => navigate("/mycenter")}>
        {translate(getText("我的"))}
      </NavItem>
    </Nav>
  );
}
